var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnlookSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_1263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43262 24.9515C5.43262 27.3155 6.28118 29.6048 7.81607 31.4089C9.35097 33.213 11.4849 34.4074 13.8309 34.7807C16.1769 35.1539 18.5728 34.6811 20.5944 33.4494C22.616 32.2176 24.1384 30.3016 24.8747 28.062C25.6109 25.81 25.5236 23.3714 24.6251 21.1816C23.7266 18.9918 22.0794 17.1877 19.9705 16.1052C17.8616 15.0228 15.4407 14.7242 13.1321 15.2592C10.8235 15.7942 8.78942 17.1379 7.37931 19.0416L15.4032 24.9391H5.43262V24.9515Z",
    fill: "#01C37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0513 24.9515C46.0513 27.3155 45.2027 29.6048 43.6678 31.4089C42.1329 33.213 39.9991 34.4074 37.653 34.7807C35.307 35.1539 32.9111 34.6811 30.8895 33.4494C28.8679 32.2176 27.3455 30.3016 26.6092 28.062C25.873 25.81 25.9603 23.3714 26.8588 21.1816C27.7573 18.9918 29.4045 17.1877 31.5134 16.1052C33.6224 15.0228 36.0433 14.7242 38.3518 15.2592C40.6604 15.7942 42.6945 17.1379 44.1046 19.0416L36.0807 24.9391H46.0513V24.9515Z",
    fill: "#01C37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7484 29.7542L28.8806 32.8771L25.7484 36L22.6162 32.8771L25.7484 29.7542Z",
    fill: "#01C37D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_1263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 21,
    fill: "",
    transform: "translate(5 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnlookSymbol);
export default __webpack_public_path__ + "static/media/AnlookSymbol.f072ad9a41c22bff0d936c41b46584b4.svg";
export { ForwardRef as ReactComponent };